var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M8 5.278a.5.5 0 0 1 .5.5V7.5h1.722a.5.5 0 1 1 0 1H8.5v1.722a.5.5 0 1 1-1 0V8.5H5.778a.5.5 0 0 1 0-1H7.5V5.778a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
};
export { SvgAdd as ReactComponent };
export default __webpack_public_path__ + "1ba692800c6d2f3b5a2ed3c0f8d2cc13.svg";